var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.taxGroups),function(taxGroup,idx){return _c('span',{key:taxGroup.id},[_c('router-link',{attrs:{"to":{ name: 'View TaxGroup', params: { id: taxGroup.id } }}},[_vm._v(" "+_vm._s(`${taxGroup.name}`)+" ")]),_vm._v(" "+_vm._s(_vm.taxGroups.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }